import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobalsLocal
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.RoutePrefix
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.defer.renderWithDeferred
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main(): Unit {
    RoutePrefix.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { example.shadcn_kotlin.ui.pages.ReactPage() }
        ctx.router.register("/components/") {
                example.shadcn_kotlin.ui.pages.components.ComponentPage() }
        ctx.router.register("/dashboard/") {
                example.shadcn_kotlin.ui.pages.dashboard.DashBoardPage() }
        ctx.router.register("/docs/") { example.shadcn_kotlin.ui.pages.docs.IndexPage() }
        ctx.router.register("/docs/components/accordion") {
                example.shadcn_kotlin.ui.pages.docs.components.AccordionPage() }
        ctx.router.register("/docs/components/alert") {
                example.shadcn_kotlin.ui.pages.docs.components.AlertPage() }
        ctx.router.register("/docs/components/alert-dialog/") {
                example.shadcn_kotlin.ui.pages.docs.components.alert_dialog.IndexPage() }
        ctx.router.register("/docs/components/aspect-ratio/") {
                example.shadcn_kotlin.ui.pages.docs.components.aspect_ratio.IndexPage() }
        ctx.router.register("/docs/components/avatar") {
                example.shadcn_kotlin.ui.pages.docs.components.AvatarPage() }
        ctx.router.register("/docs/components/badge") {
                example.shadcn_kotlin.ui.pages.docs.components.BadgePage() }
        ctx.router.register("/docs/components/button") {
                example.shadcn_kotlin.ui.pages.docs.components.ButtonPage() }
        ctx.router.register("/docs/components/calendar") {
                example.shadcn_kotlin.ui.pages.docs.components.CalendarPage() }
        ctx.router.register("/docs/components/card") {
                example.shadcn_kotlin.ui.pages.docs.components.CardPage() }
        ctx.router.register("/docs/components/checkbox") {
                example.shadcn_kotlin.ui.pages.docs.components.CheckboxPage() }
        ctx.router.register("/docs/components/collapsible") {
                example.shadcn_kotlin.ui.pages.docs.components.CollapsiblePage() }
        ctx.router.register("/docs/components/combobox") {
                example.shadcn_kotlin.ui.pages.docs.components.ComboboxPage() }
        ctx.router.register("/docs/components/command") {
                example.shadcn_kotlin.ui.pages.docs.components.CommandPage() }
        ctx.router.register("/docs/components/context-menu/") {
                example.shadcn_kotlin.ui.pages.docs.components.context_menu.IndexPage() }
        ctx.router.register("/docs/components/date-picker/") {
                example.shadcn_kotlin.ui.pages.docs.components.date_picker.IndexPage() }
        ctx.router.register("/docs/components/dialog") {
                example.shadcn_kotlin.ui.pages.docs.components.DialogPage() }
        ctx.router.register("/docs/components/dropdown-menu/") {
                example.shadcn_kotlin.ui.pages.docs.components.dropdown_menu.IndexPage() }
        ctx.router.register("/docs/components/hover-card/") {
                example.shadcn_kotlin.ui.pages.docs.components.hover_card.IndexPage() }
        ctx.router.register("/docs/components/input") {
                example.shadcn_kotlin.ui.pages.docs.components.InputPage() }
        ctx.router.register("/docs/components/label") {
                example.shadcn_kotlin.ui.pages.docs.components.LabelPage() }
        ctx.router.register("/docs/components/menubar") {
                example.shadcn_kotlin.ui.pages.docs.components.MenubarPage() }
        ctx.router.register("/docs/components/navigation-menu/") {
                example.shadcn_kotlin.ui.pages.docs.components.navigation_menu.IndexPage() }
        ctx.router.register("/docs/components/popover") {
                example.shadcn_kotlin.ui.pages.docs.components.PopoverPage() }
        ctx.router.register("/docs/components/progress") {
                example.shadcn_kotlin.ui.pages.docs.components.ProgressPage() }
        ctx.router.register("/docs/components/radio-group/") {
                example.shadcn_kotlin.ui.pages.docs.components.radio_group.IndexPage() }
        ctx.router.register("/docs/components/scroll-area/") {
                example.shadcn_kotlin.ui.pages.docs.components.scroll_area.IndexPage() }
        ctx.router.register("/docs/components/select") {
                example.shadcn_kotlin.ui.pages.docs.components.SelectPage() }
        ctx.router.register("/docs/components/separator") {
                example.shadcn_kotlin.ui.pages.docs.components.SeparatorPage() }
        ctx.router.register("/docs/components/sheet") {
                example.shadcn_kotlin.ui.pages.docs.components.SheetPage() }
        ctx.router.register("/docs/components/skeleton") {
                example.shadcn_kotlin.ui.pages.docs.components.SkeletonPage() }
        ctx.router.register("/docs/components/slider") {
                example.shadcn_kotlin.ui.pages.docs.components.SliderPage() }
        ctx.router.register("/docs/components/switch") {
                example.shadcn_kotlin.ui.pages.docs.components.SwitchPage() }
        ctx.router.register("/docs/components/table") {
                example.shadcn_kotlin.ui.pages.docs.components.TablePage() }
        ctx.router.register("/docs/components/tabs") {
                example.shadcn_kotlin.ui.pages.docs.components.TabsPage() }
        ctx.router.register("/docs/components/textarea") {
                example.shadcn_kotlin.ui.pages.docs.components.TextareaPage() }
        ctx.router.register("/docs/components/toast") {
                example.shadcn_kotlin.ui.pages.docs.components.ToastPage() }
        ctx.router.register("/docs/components/toggle") {
                example.shadcn_kotlin.ui.pages.docs.components.TogglePage() }
        ctx.router.register("/docs/components/tooltip") {
                example.shadcn_kotlin.ui.pages.docs.components.TooltipPage() }
        ctx.router.register("/docs/components/typography") {
                example.shadcn_kotlin.ui.pages.docs.components.TypographyPage() }
        ctx.router.register("/docs/dark-mode/") {
                example.shadcn_kotlin.ui.pages.docs.dark_mode.IndexPage() }
        ctx.router.register("/docs/figma") { example.shadcn_kotlin.ui.pages.docs.FigmaPage() }
        ctx.router.register("/docs/installation") {
                example.shadcn_kotlin.ui.pages.docs.InstallationPage() }
        ctx.router.register("/docs/theming") { example.shadcn_kotlin.ui.pages.docs.ThemingPage() }

        example.shadcn_kotlin.ui.initKobweb(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    router.navigateTo(window.location.href.removePrefix(window.location.origin),
            UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will overwrite them
    // the first time we render this page with their composable, dynamic versions. Think of this as
    // poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("root")!!
    while (root.firstChild != null) {
        root.removeChild(root.firstChild!!)
    }

    renderComposable(rootElementId = "root") {
        CompositionLocalProvider(
            AppGlobalsLocal provides mapOf("title" to "Shadcn Kotlin")
        ) { example.shadcn_kotlin.ui.MyApp {
              router.renderActivePage { renderWithDeferred { it() } }
        } }
    }
}
